import HyperHOC from '@platform/react/hoc/hyper'
import DecoratedText from 'ui/Element/Text/Decorated'

const HyperDecoratedText = HyperHOC(DecoratedText)

export default HyperDecoratedText
